import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'rndImg'
})
export class RndImgPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return Math.floor(Math.random() * 4) + 1;
  }

}
